import React from 'react';
import { MuralCard } from '../../../shared/components';

const Dashboard = () => {
  const getFormattedDate = () => {
    return new Date().toLocaleDateString('en-US',
      { month: 'long', day: '2-digit', weekday: 'long', year: 'numeric' }
    )
  }

  return <main className="bg-gray-50 fixed min-h-full w-full">
    <div className="py-3.5 bg-gray-100">
      <div className="container px-4 mx-auto flex items-center">
        <h1 className="border-r border-gray-300 pr-4 mr-4 font-helvetica text-2xl font-bold">HI, RALPH</h1>
        <p className="text-sm">{ getFormattedDate() }</p>
      </div>
    </div>

    <section className="container px-4 py-10 mx-auto sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4	grid gap-4">
      {
        [...Array(12).keys()].map(i => <MuralCard key={i}/>)
      }
    </section>
  </main>;
}

export default Dashboard;